import { useContext } from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, TableFooter, Typography } from '@material-ui/core';
import { ticketTypesContext } from '../TicketTypesContext';
import { DeleteIconButton, EditIconButton } from 'components';


let Results = () => {
    let service = useContext(ticketTypesContext);

    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>Type info</TableCell>
                    <TableCell />
                </TableRow>
            </TableHead>
            <TableBody>
                {service.types.map((type, index) =>
                    <TableRow hover key={index}>
                        <TableCell>{type.name}</TableCell>
                        <TableCell>{type.typeInfo}</TableCell>
                        <TableCell align="right">
                            <EditIconButton link={`/admin/tickettype/${type.id}`} />
                            <DeleteIconButton onClick={() => service.deleteTicketType(type.id)} stopPropagation />
                        </TableCell>
                    </TableRow>
                )}
            </TableBody>
            {service.types.length === 0 &&
                <TableFooter>
                    <TableRow>
                        <TableCell colSpan={3}>
                            <Typography variant="subtitle2">No ticket types found</Typography>
                        </TableCell>
                    </TableRow>
                </TableFooter>
            }
        </Table>
    );
}

export default Results;